import { render, staticRenderFns } from "./VeiculosList.vue?vue&type=template&id=562a4085"
import script from "./VeiculosList.vue?vue&type=script&lang=js"
export * from "./VeiculosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports